import { render, staticRenderFns } from "./ProjectWebsiteEditRelationsTab.vue?vue&type=template&id=7aa25f9e"
import script from "./ProjectWebsiteEditRelationsTab.vue?vue&type=script&lang=ts"
export * from "./ProjectWebsiteEditRelationsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports